"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMediaTagVolume = void 0;

var react_1 = require("react"); // Returns the real volume of the audio or video while playing,
// no matter what the supposed volume should be


var useMediaTagVolume = function useMediaTagVolume(mediaRef) {
  var _ref = (0, react_1.useState)(1),
      _ref2 = _slicedToArray(_ref, 2),
      actualVolume = _ref2[0],
      setActualVolume = _ref2[1];

  (0, react_1.useEffect)(function () {
    var ref = mediaRef.current;

    if (!ref) {
      return;
    }

    var onChange = function onChange() {
      setActualVolume(ref.volume);
    };

    ref.addEventListener('volumechange', onChange);
    return function () {
      return ref.removeEventListener('volumechange', onChange);
    };
  }, [mediaRef]);
  (0, react_1.useEffect)(function () {
    var ref = mediaRef.current;

    if (!ref) {
      return;
    }

    if (ref.volume !== actualVolume) {
      setActualVolume(ref.volume);
    }
  }, [actualVolume, mediaRef]);
  return actualVolume;
};

exports.useMediaTagVolume = useMediaTagVolume;